<template>
  <router-view />
  <FooterComponent />
  <WhatsappFloat />
  <PreLoader />
</template>

<script>
import FooterComponent from "./components/FooterComponent.vue";
import WhatsappFloat from "./components/WhatsappFloat.vue";
import store from "./store";
import PreLoader from "./components/PreLoader.vue";

export default {
  components: {
    FooterComponent,
    WhatsappFloat,
    PreLoader,
  },
  beforeCreate() {
    this.$i18n.locale = localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en";

    const body = document.getElementsByTagName("body");
    body[0].dir = this.$i18n.locale === "ar" ? "rtl" : "ltr";
    var root = document.querySelector(":root");
    const locale = this.$i18n.locale;
    if (locale === "en") {
      root.style.setProperty("--font-default", "AsenProRegular");
      root.style.setProperty("--font-primary", "AsenProBold");
      root.style.setProperty("--font-secondary", "AsenProMedium");
    } else {
      root.style.setProperty("--font-default", "LamaSansRegular");
      root.style.setProperty("--font-primary", "LamaSansBold");
      root.style.setProperty("--font-secondary", "LamaSansMedium");
    }
    store.state.phone = window.localStorage.getItem("phone");
    store.state.products = JSON.parse(window.localStorage.getItem("products"));
    store.state.instagram = window.localStorage.getItem("instagram");
    store.state.linkdin = window.localStorage.getItem("linkdin");
    store.state.twitter = window.localStorage.getItem("twitter");
    store.state.facebook = window.localStorage.getItem("facebook");
    store.state.stories = window.localStorage.getItem("stories");
    store.state.loaction_name_ar =
      window.localStorage.getItem("loaction_name_ar");
    store.state.loaction_name_en =
      window.localStorage.getItem("location_name_en");
    store.state.email = window.localStorage.getItem("email");
    store.state.welcome_message_ar =
      window.localStorage.getItem("welcome_message_ar");
    store.state.welcome_message_en =
      window.localStorage.getItem("welcome_message_en");
  },
};
</script>
